import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGeneralSetting } from "../context/GeneralSettingContext";
import { useDispatch, useSelector } from "react-redux";

const Footer = () => {
  const navigate = useNavigate();
  const { generalSetting } = useGeneralSetting();

  const { menus } = useSelector((state) => state.menu);

  const [loanServices, setLoanServices] = useState([]);
  const [insuranceServices, setInsuranceServices] = useState([]);
  const [otherServices, setOtherServices] = useState([]);

  useEffect(() => {
    if (!menus?.length) return;
    const validData = menus.filter(
      (item) => item?.url?.trim() && item.url.trim() !== "/",
    );

    // filter loans
    const loans = validData.filter((item) =>
      item.url.toLowerCase().includes("loan"),
    );

    // filter insurance
    const insurance = validData.filter((item) =>
      item.url.toLowerCase().includes("insurance"),
    );

    // others
    const others = validData.filter(
      (item) =>
        !item.url.toLowerCase().includes("loan") &&
        !item.url.toLowerCase().includes("insurance"),
    );

    setLoanServices(loans);
    setInsuranceServices(insurance);
    setOtherServices(others);
  }, [menus]);

  const handleNavigate = (url) => {
    if (!url || url === "/") return;

    if (url.startsWith("http")) {
      window.open(url, "_blank");
    } else {
      navigate(url.startsWith("/") ? url : `/${url}`);
    }
  };

  return (
    <footer>
      <div className="footer-content">
        {/* ABOUT */}
        <div className="footer-section">
          <h4>{generalSetting?.site_name || "Krishna Finconcept Services"}</h4>

          <p>
            {generalSetting?.site_description ||
              "India's leading financial services platform connecting customers with multiple banking partners."}
          </p>

          {/* SOCIAL */}
          <div className="social-icons">
            {generalSetting?.facebook_url && (
              <a
                href={generalSetting.facebook_url}
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                f
              </a>
            )}
            {generalSetting?.twitter_url && (
              <a
                href={generalSetting.twitter_url}
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                t
              </a>
            )}
            {generalSetting?.linkedin_url && (
              <a
                href={generalSetting.linkedin_url}
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                in
              </a>
            )}
            {generalSetting?.instagram_url && (
              <a
                href={generalSetting.instagram_url}
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                ig
              </a>
            )}
          </div>
        </div>

        {/* LOAN */}
        <div className="footer-section">
          <h4>Loan Products</h4>
          <ul className="footer-links">
            {loanServices.map((item) => (
              <li key={item.id}>
                <button
                  className="footer-link"
                  onClick={() => handleNavigate(item.url)}
                >
                  {item.name}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* INSURANCE */}
        <div className="footer-section">
          <h4>Insurance</h4>
          <ul className="footer-links">
            {insuranceServices.map((item) => (
              <li key={item.id}>
                <button
                  className="footer-link"
                  onClick={() => handleNavigate(item.url)}
                >
                  {item.name}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* OTHER */}
        <div className="footer-section">
          <h4>Other Services</h4>
          <ul className="footer-links">
            {otherServices.map((item) => (
              <li key={item.id}>
                <button
                  className="footer-link"
                  onClick={() => handleNavigate(item.url)}
                >
                  {item.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* COPYRIGHT */}
      <div className="copyright">
        © {new Date().getFullYear()}{" "}
        {generalSetting?.site_name || "Krishna Finconcept Services"}. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;
